import React from 'react';
import styled from '@emotion/styled';
import { Button } from '@mui/material';
import { deepMerge } from '../../../_utils/utils';

type Callback = () => void;

type ModalFooterButtonConfig = {
  text?: string;
  onClick: Callback;
  disabled?: boolean;
};

interface ModalFooterButtonsProps {
  submit: Callback | ModalFooterButtonConfig;
  cancel: Callback | ModalFooterButtonConfig;
  action?: Callback | ModalFooterButtonConfig;
  divider?: boolean;
}

const ModalFooterButtons = ({ submit, cancel, action, divider = true }: ModalFooterButtonsProps) => {
  const configs = {
    submit: deepMerge({ text: 'Submit', disabled: false }, typeof submit === 'function' ? { onClick: submit } : submit),
    cancel: deepMerge({ text: 'Cancel', disabled: false }, typeof cancel === 'function' ? { onClick: cancel } : cancel),
    action: action ? deepMerge({ text: 'Action', disabled: false }, typeof action === 'function' ? { onClick: action } : action) : null
  };

  return (
    <Wrapper divider={+divider}>
      <div>
        {configs.action && (
          <Button variant="outlined" onClick={configs.action.onClick} disabled={configs.action.disabled}>
            {configs.action.text}
          </Button>
        )}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', columnGap: 10 }}>
        <Button variant="text" onClick={configs.cancel.onClick} disabled={configs.cancel.disabled}>
          {configs.cancel.text}
        </Button>
        <Button variant="contained" onClick={configs.submit.onClick} disabled={configs.submit.disabled}>
          {configs.submit.text}
        </Button>
      </div>
    </Wrapper>
  );
};

export default ModalFooterButtons;

const Wrapper = styled.div<{ divider: number }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(2)};
  border-top: ${({ theme, divider }) => (divider ? `1px solid ${theme.palette.divider}` : 'none')};
`;
